module.exports = __webpack_public_path__ + "static/img/xf2.73662231.png";